import { render, staticRenderFns } from "./ServiceCategories.vue?vue&type=template&id=05544c70&"
import script from "./ServiceCategories.vue?vue&type=script&lang=js&"
export * from "./ServiceCategories.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCategories.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports